var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 12.5L13.3327 9.16667M9.99935 12.5V2.5V12.5ZM9.99935 12.5L6.66602 9.16667L9.99935 12.5Z",
    stroke: "url(#paint0_linear_603_30329)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 14.1665L2.18352 16.2373C2.27364 16.5979 2.4817 16.918 2.77462 17.1468C3.06755 17.3755 3.42852 17.4998 3.80018 17.4998H16.1985C16.5702 17.4998 16.9312 17.3755 17.2241 17.1468C17.517 16.918 17.7251 16.5979 17.8152 16.2373L18.3327 14.1665",
    stroke: "url(#paint1_linear_603_30329)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_603_30329",
    x1: 9.99935,
    y1: 3.30135,
    x2: 9.99935,
    y2: 15.1275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23526F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_603_30329",
    x1: 9.99935,
    y1: 14.4336,
    x2: 9.99935,
    y2: 18.3757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23526F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlack);
export default __webpack_public_path__ + "static/media/download-black.01505c5034c187fdb945021be8e1f512.svg";
export { ForwardRef as ReactComponent };